<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title"><span>Two</span></p>
<p class="normal">Dalby’s own brain was well into overdrive when he went back inside the condominium. Jack Barron’s wife was dead. His two children were dead. And now <i>his mother</i> was dead? Whoa, Dalby said to himself. What’s going on here?</p>
<p class="indent">Dalby confronted Jack. Jack watched him, still calm.</p>
<p class="indent">What’s all this about your wife and your children? Dalby asked Jack. Is it true they died? How?</p>
<p class="indent">Yes, Jack told Dalby, it was true. First his wife had died, then later his son. No one knew what caused either of the deaths.</p>
<p class="indent">They thought it might be something hereditary, or possibly some sort of environmental poisoning, like toxic waste, Jack told Dalby. But, he said, they could never figure out exactly what it was.</p>
<p class="indent">The experts were still working on it last summer, Jack added, when my four-year-old, my daughter, Ashley, died too. Nobody’s ever been able to say why any of it ever happened.</p>
<p class="indent">Jack looked at Dalby.</p>
<p class="indent">Where was this? Dalby asked.</p>
<p class="indent">Sacramento, Jack said. I come from Sacramento.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter002.vue?551d8fd2